import React from 'react'

export const useIsVerticalOverflow = (ref, event, expanded, maxHeigth) => {
  const [isOverflow, setIsOverflow] = React.useState(undefined)

  //trigger effect on event condition
  React.useEffect(() => {
    const { current } = ref

    const trigger = () => {
      if (expanded) {
        setIsOverflow(current.scrollHeight > maxHeigth)
        return
      }
      setIsOverflow(current.scrollHeight > current.offsetHeight)
    }

    if (current) {
      trigger()
    }
    //eslint-disable-next-line
  }, [ref, event])

  return isOverflow
}
